<style>
.bg-danger-duplicated{
  background-color: #f85c5c1a !important;
}
</style>
<template>
  <tr  v-bind:class = "(item.isDuplicated || item.isOptionRequired)?'bg-danger-duplicated':''" >
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
      <div v-show="item.isDuplicated" class="text-danger">* รายการซ้ำ</div>
    </td> 
    <td class="form-group"> 
      <select2 
        :disabled="!item.isAgentEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control'"
        :id="'odcAgentCode' + _uid"
        :name="'odcAgentCode' + _uid"
        :select2-options="OdcAgentOptions" 
        v-model="item.odcAgentCode"
        ref="odcAgentCode" 
        @selectChange="onAgentChange"
      ></select2> 
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :disabled="!item.isSubAgentEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control'"
        :id="'odcSubAgentCode' + _uid"
        :name="'odcSubAgentCode' + _uid" 
        :select2-options="OdcSubAgentOptions"  
        v-model="item.odcSubAgentCode"
        ref="odcSubAgentCode" 
        @selectChange="onSubAgentChange"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group"> 
      <div v-show="item.isOptionRequired" class="text-danger">* กรุณาเลือก</div>    
      <div class="kt-radio-inline" :id="'gOdcRouteAgentOption'+ _uid" v-show="!item.HideGroupOdcRouteAgentOptionShow">
      
        <label
          class="kt-radio"
          v-for="(plRouteAgentOption,
          pl) in RouteAgentOptions"
          :key="pl"
        >
          <input
            type="radio"
            :id="'odcRouteAgentOptionId'+ _uid" 
            :name="'odcRouteAgentOption'+ _uid " 
            :value="plRouteAgentOption.id"
            v-model="item.odcRouteAgentOption"  
            @change="onRouteAgentOptionGroupChange"
          />
          <!-- @change="onProductGroupChange($event)" -->
          <span></span>
          {{ plRouteAgentOption.text }}
        </label>
        <a  :id="'cOdcRouteAgentOption'+ _uid"
            href="#"
            title="reset"
            class="btn btn-sm btn-clean btn-icon btn-icon-md"
            @click.prevent="onClearRadioVal('odcRouteAgentOption' + _uid )"
          >
            <i class="fa fa-times-circle"></i>
          </a>
      </div>
      <span class="form-text"></span>  
    </td> 
    <td class="form-group">
      <center>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveItemClick"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>

<script>
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    var self = this;
    var ldata = [];
    
    ldata.push({
      id: "AGENT_SHOP",
      text:  "ร้านค้าทั้งหมดของตัวแทนจำหน่าย",
    });
    ldata.push({
      id:"AGENT_SHOP_SUBAGENT_SHOP",
      text: "ร้านค้าทั้งหมดของตัวแทนจำหน่าย และ ร้านค้าทั้งหมดของตัวแทนจำหน่ายย่อย",
    });

    return { 
      itemAgentCode : null, 
      RouteAgentOptions : ldata ,
      OdcAgentOptions : { 
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          //type: "POST",
          delay: 300,
          url: "/Api/Agents/Select2Agents",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        } 
      },
      OdcSubAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
        allowClear: true,
        ajax: {
          delay: 300,   
          url: "/Api/Agents/Select2SubShopAgent", 
          data: function(params) { 
            var agent  = null;
            if (self.item.odcAgentCode !== undefined) {
              if (self.item.odcAgentCode) {
                agent = self.item.odcAgentCode ;
              }
            }   

            var query = {
              agentCode :  agent , 
              all: true,
              onlySubAgent: true, 
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcBudgetIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/BudgetBrand/Select2BudgetQuery",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcQuotaIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  computed: {
    totalCal() {
      return (this.item.odcTotal = this.item.odcQuantity * this.item.odcPrice);
    }
  },
  methods: { 
    onClearRadioVal: function(name ) {
      $("input[name=" + name + "]").prop("checked", false);  
      
      setTimeout(() => { 
        this.$parent.odcitems[this.rowIndex].isSubAgentEditable = true ;
        
        this.$parent.odcitems[this.rowIndex].isOptionRequired = true ;
      }, 100);
    },
    onRemoveItemClick(e) {
      //alert(this.rowIndex);
      //this.$parent.odcitems.splice(this.rowIndex-1, 1);
      this.$emit("removeItem", this.rowIndex, this.item);
    }, 
    onAgentChange: function(id, text, data, ref)  {  
      var self = this;   
      // clear sub agent 
      $("#odcSubAgentCode"+self._uid).val("").trigger("change"); 
      
      this.$parent.onValidateDuplicated(); 
    }, 
    onRouteAgentOptionGroupChange: function(id, text, data, ref) {
      var self = this; 

      this.$parent.odcitems[this.rowIndex].isOptionRequired = false ;

      if(this.$parent.odcitems[this.rowIndex].odcRouteAgentOption == "AGENT_SHOP_SUBAGENT_SHOP" ){
        this.$parent.odcitems[this.rowIndex].isSubAgentEditable = false ;
        this.$parent.odcitems[this.rowIndex].odcSubAgentCode = null ;
        $("#odcSubAgentCode"+self._uid).val("").trigger("change"); 
      }
      else{
        this.$parent.odcitems[this.rowIndex].isSubAgentEditable = true ;
      }  
    }, 
    onSubAgentChange: function(id, text, data, ref) { 
      var self = this;   
 
      if( ($("#odcAgentCode"+self._uid).val()==null || $("#odcAgentCode"+self._uid).val().length <=0 ) &&  ($("#odcSubAgentCode"+self._uid).val() != null && $("#odcSubAgentCode"+self._uid).val().length >0 ))
      {
        $("input[name=" + 'odcRouteAgentOption' + self._uid + "]").prop("checked", false);
        $("#gOdcRouteAgentOption"+self._uid).hide();
        this.$parent.odcitems[this.rowIndex].isOptionRequired = false ;  
      }
      else{
        $("#gOdcRouteAgentOption"+self._uid).show();
          if( this.$parent.odcitems[this.rowIndex].odcRouteAgentOption != null){
            this.$parent.odcitems[this.rowIndex].isOptionRequired = false ;  
          }
          else{
            this.$parent.odcitems[this.rowIndex].isOptionRequired = true ; 
          }
      } 

      this.$parent.onValidateDuplicated();

    }, 
  },
  mounted() {

    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/CompanyProfile/ItemRow.vue